var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReporticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9604_12673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 5.99805L10.5 1.49805H4.5C4.10218 1.49805 3.72064 1.65608 3.43934 1.93739C3.15804 2.21869 3 2.60022 3 2.99805V14.998C3 15.3959 3.15804 15.7774 3.43934 16.0587C3.72064 16.34 4.10218 16.498 4.5 16.498H13.5C13.8978 16.498 14.2794 16.34 14.5607 16.0587C14.842 15.7774 15 15.3959 15 14.998V5.99805ZM6.75 14.248H5.25V7.49805H6.75V14.248ZM9.75 14.248H8.25V9.74805H9.75V14.248ZM12.75 14.248H11.25V11.998H12.75V14.248ZM10.5 6.74805H9.75V2.99805L13.5 6.74805H10.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9604_12673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporticon);
export default __webpack_public_path__ + "static/media/reporticon.77d0c6c91e971671a80b7a041812b8b9.svg";
export { ForwardRef as ReactComponent };